//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//     Please use NDAW.TimeZoneUpdateTool to regenerate it
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
export type TimeZoneOption = {
	readonly identifier: string;
	readonly cityName: string;
};

export const timeZoneOptions: readonly TimeZoneOption[] = [
	{
		identifier: "Africa/Algiers",
		cityName: "Algiers"
	},
	{
		identifier: "Atlantic/Cape_Verde",
		cityName: "Praia"
	},
	{
		identifier: "Africa/Ndjamena",
		cityName: "N'Djamena"
	},
	{
		identifier: "Africa/Abidjan",
		cityName: "Abidjan"
	},
	{
		identifier: "Africa/Cairo",
		cityName: "Cairo"
	},
	{
		identifier: "Africa/Bissau",
		cityName: "Bissau"
	},
	{
		identifier: "Africa/Nairobi",
		cityName: "Nairobi"
	},
	{
		identifier: "Africa/Monrovia",
		cityName: "Monrovia"
	},
	{
		identifier: "Africa/Tripoli",
		cityName: "Tripoli"
	},
	{
		identifier: "Indian/Mauritius",
		cityName: "Port Louis"
	},
	{
		identifier: "Africa/Casablanca",
		cityName: "Casablanca"
	},
	{
		identifier: "Africa/El_Aaiun",
		cityName: "Laayoune"
	},
	{
		identifier: "Africa/Maputo",
		cityName: "Maputo"
	},
	{
		identifier: "Africa/Windhoek",
		cityName: "Windhoek"
	},
	{
		identifier: "Africa/Lagos",
		cityName: "Lagos"
	},
	{
		identifier: "Africa/Sao_Tome",
		cityName: "São Tomé"
	},
	{
		identifier: "Africa/Johannesburg",
		cityName: "Johannesburg"
	},
	{
		identifier: "Africa/Khartoum",
		cityName: "Khartoum"
	},
	{
		identifier: "Africa/Juba",
		cityName: "Juba"
	},
	{
		identifier: "Africa/Tunis",
		cityName: "Tunis"
	},
	{
		identifier: "Asia/Kabul",
		cityName: "Kabul"
	},
	{
		identifier: "Asia/Yerevan",
		cityName: "Yerevan"
	},
	{
		identifier: "Asia/Baku",
		cityName: "Baku"
	},
	{
		identifier: "Asia/Dhaka",
		cityName: "Dhaka"
	},
	{
		identifier: "Asia/Thimphu",
		cityName: "Thimphu"
	},
	{
		identifier: "Indian/Chagos",
		cityName: "Chagos"
	},
	{
		identifier: "Asia/Yangon",
		cityName: "Yangon"
	},
	{
		identifier: "Asia/Shanghai",
		cityName: "Shanghai"
	},
	{
		identifier: "Asia/Hong_Kong",
		cityName: "Hong Kong"
	},
	{
		identifier: "Asia/Taipei",
		cityName: "Taipei"
	},
	{
		identifier: "Asia/Macau",
		cityName: "Macau"
	},
	{
		identifier: "Asia/Nicosia",
		cityName: "Nicosia"
	},
	{
		identifier: "Asia/Famagusta",
		cityName: "Famagusta"
	},
	{
		identifier: "Asia/Tbilisi",
		cityName: "Tbilisi"
	},
	{
		identifier: "Asia/Dili",
		cityName: "Dili"
	},
	{
		identifier: "Asia/Kolkata",
		cityName: "Mumbai"
	},
	{
		identifier: "Asia/Jakarta",
		cityName: "Jakarta"
	},
	{
		identifier: "Asia/Pontianak",
		cityName: "Pontianak"
	},
	{
		identifier: "Asia/Makassar",
		cityName: "Makassar"
	},
	{
		identifier: "Asia/Jayapura",
		cityName: "Jayapura"
	},
	{
		identifier: "Asia/Tehran",
		cityName: "Tehran"
	},
	{
		identifier: "Asia/Baghdad",
		cityName: "Baghdad"
	},
	{
		identifier: "Asia/Jerusalem",
		cityName: "Jerusalem"
	},
	{
		identifier: "Asia/Tokyo",
		cityName: "Tokyo"
	},
	{
		identifier: "Asia/Amman",
		cityName: "Amman"
	},
	{
		identifier: "Asia/Almaty",
		cityName: "Almaty"
	},
	{
		identifier: "Asia/Qyzylorda",
		cityName: "Kyzylorda"
	},
	{
		identifier: "Asia/Qostanay",
		cityName: "Kostanay"
	},
	{
		identifier: "Asia/Aqtobe",
		cityName: "Aktobe"
	},
	{
		identifier: "Asia/Aqtau",
		cityName: "Shevchenko"
	},
	{
		identifier: "Asia/Atyrau",
		cityName: "Atyrau"
	},
	{
		identifier: "Asia/Oral",
		cityName: "Oral"
	},
	{
		identifier: "Asia/Bishkek",
		cityName: "Bishkek"
	},
	{
		identifier: "Asia/Seoul",
		cityName: "Seoul"
	},
	{
		identifier: "Asia/Pyongyang",
		cityName: "Pyongyang"
	},
	{
		identifier: "Asia/Beirut",
		cityName: "Beirut"
	},
	{
		identifier: "Asia/Kuching",
		cityName: "Kota Kinabalu"
	},
	{
		identifier: "Indian/Maldives",
		cityName: "Male"
	},
	{
		identifier: "Asia/Hovd",
		cityName: "Ulaangom"
	},
	{
		identifier: "Asia/Ulaanbaatar",
		cityName: "Ulan Bator"
	},
	{
		identifier: "Asia/Choibalsan",
		cityName: "Baruun-Urt"
	},
	{
		identifier: "Asia/Kathmandu",
		cityName: "Kathmandu"
	},
	{
		identifier: "Asia/Karachi",
		cityName: "Karachi"
	},
	{
		identifier: "Asia/Gaza",
		cityName: "Gaza"
	},
	{
		identifier: "Asia/Hebron",
		cityName: "East Jerusalem"
	},
	{
		identifier: "Asia/Manila",
		cityName: "Quezon City"
	},
	{
		identifier: "Asia/Qatar",
		cityName: "Doha"
	},
	{
		identifier: "Asia/Riyadh",
		cityName: "Jeddah"
	},
	{
		identifier: "Asia/Singapore",
		cityName: "Singapore"
	},
	{
		identifier: "Asia/Colombo",
		cityName: "Colombo"
	},
	{
		identifier: "Asia/Damascus",
		cityName: "Aleppo"
	},
	{
		identifier: "Asia/Dushanbe",
		cityName: "Dushanbe"
	},
	{
		identifier: "Asia/Bangkok",
		cityName: "Hanoi"
	},
	{
		identifier: "Asia/Ashgabat",
		cityName: "Ashgabat"
	},
	{
		identifier: "Asia/Dubai",
		cityName: "Dubai"
	},
	{
		identifier: "Asia/Samarkand",
		cityName: "Samarkand"
	},
	{
		identifier: "Asia/Tashkent",
		cityName: "Tashkent"
	},
	{
		identifier: "Asia/Ho_Chi_Minh",
		cityName: "Ho Chi Minh City"
	},
	{
		identifier: "Australia/Darwin",
		cityName: "Darwin"
	},
	{
		identifier: "Australia/Perth",
		cityName: "Perth"
	},
	{
		identifier: "Australia/Eucla",
		cityName: "Eucla"
	},
	{
		identifier: "Australia/Brisbane",
		cityName: "Brisbane"
	},
	{
		identifier: "Australia/Lindeman",
		cityName: "Lindeman"
	},
	{
		identifier: "Australia/Adelaide",
		cityName: "Adelaide"
	},
	{
		identifier: "Australia/Hobart",
		cityName: "Hobart"
	},
	{
		identifier: "Australia/Melbourne",
		cityName: "Melbourne"
	},
	{
		identifier: "Australia/Sydney",
		cityName: "Sydney"
	},
	{
		identifier: "Australia/Broken_Hill",
		cityName: "Broken Hill"
	},
	{
		identifier: "Australia/Lord_Howe",
		cityName: "Lord Howe"
	},
	{
		identifier: "Pacific/Fiji",
		cityName: "Nasinu"
	},
	{
		identifier: "Pacific/Gambier",
		cityName: "Gambier"
	},
	{
		identifier: "Pacific/Marquesas",
		cityName: "Marquesas"
	},
	{
		identifier: "Pacific/Tahiti",
		cityName: "Faaa"
	},
	{
		identifier: "Pacific/Guam",
		cityName: "Dededo Village"
	},
	{
		identifier: "Pacific/Tarawa",
		cityName: "Tarawa"
	},
	{
		identifier: "Pacific/Kiritimati",
		cityName: "Kiritimati"
	},
	{
		identifier: "Pacific/Kwajalein",
		cityName: "Kwajalein"
	},
	{
		identifier: "Pacific/Kosrae",
		cityName: "Kosrae"
	},
	{
		identifier: "Pacific/Nauru",
		cityName: "Yaren"
	},
	{
		identifier: "Pacific/Noumea",
		cityName: "Nouméa"
	},
	{
		identifier: "Pacific/Auckland",
		cityName: "Auckland"
	},
	{
		identifier: "Pacific/Chatham",
		cityName: "Chatham"
	},
	{
		identifier: "Pacific/Rarotonga",
		cityName: "Avarua"
	},
	{
		identifier: "Pacific/Niue",
		cityName: "Alofi"
	},
	{
		identifier: "Pacific/Norfolk",
		cityName: "Kingston"
	},
	{
		identifier: "Pacific/Palau",
		cityName: "Ngerulmud"
	},
	{
		identifier: "Pacific/Port_Moresby",
		cityName: "Port Moresby"
	},
	{
		identifier: "Pacific/Bougainville",
		cityName: "Arawa"
	},
	{
		identifier: "Pacific/Pitcairn",
		cityName: "Adamstown"
	},
	{
		identifier: "Pacific/Pago_Pago",
		cityName: "Pago Pago"
	},
	{
		identifier: "Pacific/Apia",
		cityName: "Apia"
	},
	{
		identifier: "Pacific/Guadalcanal",
		cityName: "Honiara"
	},
	{
		identifier: "Pacific/Tongatapu",
		cityName: "Nuku‘alofa"
	},
	{
		identifier: "Pacific/Efate",
		cityName: "Port-Vila"
	},
	{
		identifier: "Europe/London",
		cityName: "London"
	},
	{
		identifier: "Europe/Dublin",
		cityName: "Dublin"
	},
	{
		identifier: "Europe/Tirane",
		cityName: "Tirana"
	},
	{
		identifier: "Europe/Andorra",
		cityName: "Andorra la Vella"
	},
	{
		identifier: "Europe/Vienna",
		cityName: "Vienna"
	},
	{
		identifier: "Europe/Minsk",
		cityName: "Minsk"
	},
	{
		identifier: "Europe/Brussels",
		cityName: "Brussels"
	},
	{
		identifier: "Europe/Sofia",
		cityName: "Sofia"
	},
	{
		identifier: "Europe/Prague",
		cityName: "Prague"
	},
	{
		identifier: "Atlantic/Faroe",
		cityName: "Tórshavn"
	},
	{
		identifier: "America/Danmarkshavn",
		cityName: "Danmarkshavn"
	},
	{
		identifier: "America/Scoresbysund",
		cityName: "Scoresbysund"
	},
	{
		identifier: "America/Nuuk",
		cityName: "Nuuk"
	},
	{
		identifier: "America/Thule",
		cityName: "Thule"
	},
	{
		identifier: "Europe/Tallinn",
		cityName: "Tallinn"
	},
	{
		identifier: "Europe/Helsinki",
		cityName: "Helsinki"
	},
	{
		identifier: "Europe/Paris",
		cityName: "Paris"
	},
	{
		identifier: "Europe/Berlin",
		cityName: "Berlin"
	},
	{
		identifier: "Europe/Gibraltar",
		cityName: "Gibraltar"
	},
	{
		identifier: "Europe/Athens",
		cityName: "Athens"
	},
	{
		identifier: "Europe/Budapest",
		cityName: "Budapest"
	},
	{
		identifier: "Europe/Rome",
		cityName: "Rome"
	},
	{
		identifier: "Europe/Riga",
		cityName: "Riga"
	},
	{
		identifier: "Europe/Vilnius",
		cityName: "Vilnius"
	},
	{
		identifier: "Europe/Malta",
		cityName: "San Pawl il-Baħar"
	},
	{
		identifier: "Europe/Chisinau",
		cityName: "Chisinau"
	},
	{
		identifier: "Europe/Warsaw",
		cityName: "Warsaw"
	},
	{
		identifier: "Europe/Lisbon",
		cityName: "Lisbon"
	},
	{
		identifier: "Atlantic/Azores",
		cityName: "Ponta Delgada"
	},
	{
		identifier: "Atlantic/Madeira",
		cityName: "Funchal"
	},
	{
		identifier: "Europe/Bucharest",
		cityName: "Bucharest"
	},
	{
		identifier: "Europe/Kaliningrad",
		cityName: "Kaliningrad"
	},
	{
		identifier: "Europe/Moscow",
		cityName: "Moscow"
	},
	{
		identifier: "Europe/Simferopol",
		cityName: "Sevastopol"
	},
	{
		identifier: "Europe/Astrakhan",
		cityName: "Astrakhan"
	},
	{
		identifier: "Europe/Volgograd",
		cityName: "Volgograd"
	},
	{
		identifier: "Europe/Saratov",
		cityName: "Saratov"
	},
	{
		identifier: "Europe/Kirov",
		cityName: "Kirov"
	},
	{
		identifier: "Europe/Samara",
		cityName: "Samara"
	},
	{
		identifier: "Europe/Ulyanovsk",
		cityName: "Ulyanovsk"
	},
	{
		identifier: "Asia/Yekaterinburg",
		cityName: "Yekaterinburg"
	},
	{
		identifier: "Asia/Omsk",
		cityName: "Omsk"
	},
	{
		identifier: "Asia/Barnaul",
		cityName: "Barnaul"
	},
	{
		identifier: "Asia/Novosibirsk",
		cityName: "Novosibirsk"
	},
	{
		identifier: "Asia/Tomsk",
		cityName: "Tomsk"
	},
	{
		identifier: "Asia/Novokuznetsk",
		cityName: "Kemerovo"
	},
	{
		identifier: "Asia/Krasnoyarsk",
		cityName: "Krasnoyarsk"
	},
	{
		identifier: "Asia/Irkutsk",
		cityName: "Irkutsk"
	},
	{
		identifier: "Asia/Chita",
		cityName: "Chita"
	},
	{
		identifier: "Asia/Yakutsk",
		cityName: "Yakutsk"
	},
	{
		identifier: "Asia/Vladivostok",
		cityName: "Khabarovsk"
	},
	{
		identifier: "Asia/Khandyga",
		cityName: "Khandyga"
	},
	{
		identifier: "Asia/Sakhalin",
		cityName: "Yuzhno-Sakhalinsk"
	},
	{
		identifier: "Asia/Magadan",
		cityName: "Magadan"
	},
	{
		identifier: "Asia/Srednekolymsk",
		cityName: "Srednekolymsk"
	},
	{
		identifier: "Asia/Ust-Nera",
		cityName: "Ust-Nera"
	},
	{
		identifier: "Asia/Kamchatka",
		cityName: "Petropavlovsk-Kamchatsky"
	},
	{
		identifier: "Asia/Anadyr",
		cityName: "Anadyr"
	},
	{
		identifier: "Europe/Belgrade",
		cityName: "Belgrade"
	},
	{
		identifier: "Europe/Madrid",
		cityName: "Madrid"
	},
	{
		identifier: "Africa/Ceuta",
		cityName: "Melilla"
	},
	{
		identifier: "Atlantic/Canary",
		cityName: "Las Palmas de Gran Canaria"
	},
	{
		identifier: "Europe/Zurich",
		cityName: "Zürich"
	},
	{
		identifier: "Europe/Istanbul",
		cityName: "Istanbul"
	},
	{
		identifier: "America/New_York",
		cityName: "New York City"
	},
	{
		identifier: "America/Chicago",
		cityName: "Chicago"
	},
	{
		identifier: "America/North_Dakota/New_Salem",
		cityName: "Mandan"
	},
	{
		identifier: "America/Denver",
		cityName: "Denver"
	},
	{
		identifier: "America/Los_Angeles",
		cityName: "Los Angeles"
	},
	{
		identifier: "America/Juneau",
		cityName: "Juneau"
	},
	{
		identifier: "America/Sitka",
		cityName: "Sitka"
	},
	{
		identifier: "America/Metlakatla",
		cityName: "Metlakatla"
	},
	{
		identifier: "America/Yakutat",
		cityName: "Yakutat"
	},
	{
		identifier: "America/Anchorage",
		cityName: "Anchorage"
	},
	{
		identifier: "America/Adak",
		cityName: "Adak"
	},
	{
		identifier: "Pacific/Honolulu",
		cityName: "Honolulu"
	},
	{
		identifier: "America/Phoenix",
		cityName: "Phoenix"
	},
	{
		identifier: "America/Boise",
		cityName: "Boise"
	},
	{
		identifier: "America/Indiana/Indianapolis",
		cityName: "Indianapolis"
	},
	{
		identifier: "America/Indiana/Marengo",
		cityName: "Marengo"
	},
	{
		identifier: "America/Indiana/Vincennes",
		cityName: "Jasper"
	},
	{
		identifier: "America/Indiana/Tell_City",
		cityName: "Tell City"
	},
	{
		identifier: "America/Indiana/Petersburg",
		cityName: "Petersburg"
	},
	{
		identifier: "America/Indiana/Knox",
		cityName: "Knox"
	},
	{
		identifier: "America/Indiana/Winamac",
		cityName: "Winamac"
	},
	{
		identifier: "America/Indiana/Vevay",
		cityName: "Vevay"
	},
	{
		identifier: "America/Kentucky/Louisville",
		cityName: "Louisville"
	},
	{
		identifier: "America/Kentucky/Monticello",
		cityName: "Monticello"
	},
	{
		identifier: "America/Detroit",
		cityName: "Detroit"
	},
	{
		identifier: "America/Menominee",
		cityName: "Menominee"
	},
	{
		identifier: "America/St_Johns",
		cityName: "St. John's"
	},
	{
		identifier: "America/Goose_Bay",
		cityName: "Goose Bay"
	},
	{
		identifier: "America/Halifax",
		cityName: "Halifax"
	},
	{
		identifier: "America/Glace_Bay",
		cityName: "Sydney"
	},
	{
		identifier: "America/Moncton",
		cityName: "Moncton"
	},
	{
		identifier: "America/Toronto",
		cityName: "Toronto"
	},
	{
		identifier: "America/Winnipeg",
		cityName: "Winnipeg"
	},
	{
		identifier: "America/Regina",
		cityName: "Saskatoon"
	},
	{
		identifier: "America/Swift_Current",
		cityName: "Swift Current"
	},
	{
		identifier: "America/Edmonton",
		cityName: "Calgary"
	},
	{
		identifier: "America/Vancouver",
		cityName: "Vancouver"
	},
	{
		identifier: "America/Dawson_Creek",
		cityName: "Fort St. John"
	},
	{
		identifier: "America/Fort_Nelson",
		cityName: "Fort Nelson"
	},
	{
		identifier: "America/Iqaluit",
		cityName: "Iqaluit"
	},
	{
		identifier: "America/Resolute",
		cityName: "Resolute"
	},
	{
		identifier: "America/Rankin_Inlet",
		cityName: "Rankin Inlet"
	},
	{
		identifier: "America/Cambridge_Bay",
		cityName: "Cambridge Bay"
	},
	{
		identifier: "America/Inuvik",
		cityName: "Inuvik"
	},
	{
		identifier: "America/Whitehorse",
		cityName: "Whitehorse"
	},
	{
		identifier: "America/Dawson",
		cityName: "Dawson"
	},
	{
		identifier: "America/Cancun",
		cityName: "Cancún"
	},
	{
		identifier: "America/Merida",
		cityName: "Mérida"
	},
	{
		identifier: "America/Matamoros",
		cityName: "Reynosa"
	},
	{
		identifier: "America/Monterrey",
		cityName: "Monterrey"
	},
	{
		identifier: "America/Mexico_City",
		cityName: "Mexico City"
	},
	{
		identifier: "America/Ojinaga",
		cityName: "Manuel Ojinaga"
	},
	{
		identifier: "America/Chihuahua",
		cityName: "Chihuahua"
	},
	{
		identifier: "America/Hermosillo",
		cityName: "Hermosillo"
	},
	{
		identifier: "America/Mazatlan",
		cityName: "Culiacán"
	},
	{
		identifier: "America/Bahia_Banderas",
		cityName: "Mezcales"
	},
	{
		identifier: "America/Tijuana",
		cityName: "Tijuana"
	},
	{
		identifier: "America/Barbados",
		cityName: "Bridgetown"
	},
	{
		identifier: "America/Belize",
		cityName: "Belize City"
	},
	{
		identifier: "Atlantic/Bermuda",
		cityName: "Hamilton"
	},
	{
		identifier: "America/Costa_Rica",
		cityName: "San José"
	},
	{
		identifier: "America/Havana",
		cityName: "Havana"
	},
	{
		identifier: "America/Santo_Domingo",
		cityName: "Santo Domingo"
	},
	{
		identifier: "America/El_Salvador",
		cityName: "San Salvador"
	},
	{
		identifier: "America/Guatemala",
		cityName: "Guatemala City"
	},
	{
		identifier: "America/Port-au-Prince",
		cityName: "Port-au-Prince"
	},
	{
		identifier: "America/Tegucigalpa",
		cityName: "Tegucigalpa"
	},
	{
		identifier: "America/Jamaica",
		cityName: "Kingston"
	},
	{
		identifier: "America/Martinique",
		cityName: "Fort-de-France"
	},
	{
		identifier: "America/Managua",
		cityName: "Managua"
	},
	{
		identifier: "America/Panama",
		cityName: "Panamá"
	},
	{
		identifier: "America/Puerto_Rico",
		cityName: "San Juan"
	},
	{
		identifier: "America/Miquelon",
		cityName: "Saint-Pierre"
	},
	{
		identifier: "America/Grand_Turk",
		cityName: "Cockburn Town"
	},
	{
		identifier: "America/Argentina/Buenos_Aires",
		cityName: "Buenos Aires"
	},
	{
		identifier: "America/Argentina/Cordoba",
		cityName: "Córdoba"
	},
	{
		identifier: "America/Argentina/Salta",
		cityName: "Salta"
	},
	{
		identifier: "America/Argentina/Tucuman",
		cityName: "San Miguel de Tucumán"
	},
	{
		identifier: "America/Argentina/La_Rioja",
		cityName: "La Rioja"
	},
	{
		identifier: "America/Argentina/San_Juan",
		cityName: "San Juan"
	},
	{
		identifier: "America/Argentina/Jujuy",
		cityName: "San Salvador de Jujuy"
	},
	{
		identifier: "America/Argentina/Catamarca",
		cityName: "Catamarca"
	},
	{
		identifier: "America/Argentina/Mendoza",
		cityName: "San Rafael"
	},
	{
		identifier: "America/Argentina/San_Luis",
		cityName: "San Luis"
	},
	{
		identifier: "America/Argentina/Rio_Gallegos",
		cityName: "Río Gallegos"
	},
	{
		identifier: "America/Argentina/Ushuaia",
		cityName: "Ushuaia"
	},
	{
		identifier: "America/La_Paz",
		cityName: "La Paz"
	},
	{
		identifier: "America/Noronha",
		cityName: "Fernando de Noronha"
	},
	{
		identifier: "America/Belem",
		cityName: "Belém"
	},
	{
		identifier: "America/Santarem",
		cityName: "Santarém"
	},
	{
		identifier: "America/Fortaleza",
		cityName: "Fortaleza"
	},
	{
		identifier: "America/Recife",
		cityName: "Recife"
	},
	{
		identifier: "America/Araguaina",
		cityName: "Palmas"
	},
	{
		identifier: "America/Maceio",
		cityName: "Maceió"
	},
	{
		identifier: "America/Bahia",
		cityName: "Salvador"
	},
	{
		identifier: "America/Sao_Paulo",
		cityName: "São Paulo"
	},
	{
		identifier: "America/Campo_Grande",
		cityName: "Campo Grande"
	},
	{
		identifier: "America/Cuiaba",
		cityName: "Cuiabá"
	},
	{
		identifier: "America/Porto_Velho",
		cityName: "Porto Velho"
	},
	{
		identifier: "America/Boa_Vista",
		cityName: "Boa Vista"
	},
	{
		identifier: "America/Manaus",
		cityName: "Manaus"
	},
	{
		identifier: "America/Eirunepe",
		cityName: "Eirunepé"
	},
	{
		identifier: "America/Rio_Branco",
		cityName: "Rio Branco"
	},
	{
		identifier: "America/Santiago",
		cityName: "Santiago"
	},
	{
		identifier: "America/Punta_Arenas",
		cityName: "Punta Arenas"
	},
	{
		identifier: "Pacific/Easter",
		cityName: "Easter Island"
	},
	{
		identifier: "Antarctica/Palmer",
		cityName: "Palmer"
	},
	{
		identifier: "America/Bogota",
		cityName: "Bogotá"
	},
	{
		identifier: "America/Guayaquil",
		cityName: "Quito"
	},
	{
		identifier: "Pacific/Galapagos",
		cityName: "Galapagos"
	},
	{
		identifier: "Atlantic/Stanley",
		cityName: "Stanley"
	},
	{
		identifier: "America/Cayenne",
		cityName: "Cayenne"
	},
	{
		identifier: "America/Guyana",
		cityName: "Georgetown"
	},
	{
		identifier: "America/Asuncion",
		cityName: "Asunción"
	},
	{
		identifier: "America/Lima",
		cityName: "Lima"
	},
	{
		identifier: "Atlantic/South_Georgia",
		cityName: "Grytviken"
	},
	{
		identifier: "America/Paramaribo",
		cityName: "Paramaribo"
	},
	{
		identifier: "America/Montevideo",
		cityName: "Montevideo"
	},
	{
		identifier: "America/Caracas",
		cityName: "Caracas"
	},
	{
		identifier: "Australia/Tasmania",
		cityName: "Tasmania"
	},
	{
		identifier: "Australia/Victoria",
		cityName: "Victoria"
	},
	{
		identifier: "Pacific/Samoa",
		cityName: "Samoa"
	},
	{
		identifier: "Africa/Accra",
		cityName: "Accra"
	},
	{
		identifier: "Africa/Addis_Ababa",
		cityName: "Addis Ababa"
	},
	{
		identifier: "Africa/Asmara",
		cityName: "Asmara"
	},
	{
		identifier: "Africa/Bamako",
		cityName: "Bamako"
	},
	{
		identifier: "Africa/Bangui",
		cityName: "Bangui"
	},
	{
		identifier: "Africa/Banjul",
		cityName: "Banjul"
	},
	{
		identifier: "Africa/Blantyre",
		cityName: "Lilongwe"
	},
	{
		identifier: "Africa/Brazzaville",
		cityName: "Brazzaville"
	},
	{
		identifier: "Africa/Bujumbura",
		cityName: "Bujumbura"
	},
	{
		identifier: "Africa/Conakry",
		cityName: "Camayenne"
	},
	{
		identifier: "Africa/Dakar",
		cityName: "Dakar"
	},
	{
		identifier: "Africa/Dar_es_Salaam",
		cityName: "Dar es Salaam"
	},
	{
		identifier: "Africa/Djibouti",
		cityName: "Djibouti"
	},
	{
		identifier: "Africa/Douala",
		cityName: "Douala"
	},
	{
		identifier: "Africa/Freetown",
		cityName: "Freetown"
	},
	{
		identifier: "Africa/Gaborone",
		cityName: "Gaborone"
	},
	{
		identifier: "Africa/Harare",
		cityName: "Harare"
	},
	{
		identifier: "Africa/Kampala",
		cityName: "Kampala"
	},
	{
		identifier: "Africa/Kigali",
		cityName: "Kigali"
	},
	{
		identifier: "Africa/Kinshasa",
		cityName: "Kinshasa"
	},
	{
		identifier: "Africa/Libreville",
		cityName: "Libreville"
	},
	{
		identifier: "Africa/Lome",
		cityName: "Lomé"
	},
	{
		identifier: "Africa/Luanda",
		cityName: "Luanda"
	},
	{
		identifier: "Africa/Lubumbashi",
		cityName: "Lubumbashi"
	},
	{
		identifier: "Africa/Lusaka",
		cityName: "Lusaka"
	},
	{
		identifier: "Africa/Malabo",
		cityName: "Bata"
	},
	{
		identifier: "Africa/Maseru",
		cityName: "Maseru"
	},
	{
		identifier: "Africa/Mbabane",
		cityName: "Manzini"
	},
	{
		identifier: "Africa/Mogadishu",
		cityName: "Mogadishu"
	},
	{
		identifier: "Africa/Niamey",
		cityName: "Niamey"
	},
	{
		identifier: "Africa/Nouakchott",
		cityName: "Nouakchott"
	},
	{
		identifier: "Africa/Ouagadougou",
		cityName: "Ouagadougou"
	},
	{
		identifier: "Africa/Porto-Novo",
		cityName: "Cotonou"
	},
	{
		identifier: "America/Anguilla",
		cityName: "The Valley"
	},
	{
		identifier: "America/Antigua",
		cityName: "Saint John’s"
	},
	{
		identifier: "America/Aruba",
		cityName: "Oranjestad"
	},
	{
		identifier: "America/Atikokan",
		cityName: "Atikokan"
	},
	{
		identifier: "America/Blanc-Sablon",
		cityName: "Blanc-Sablon"
	},
	{
		identifier: "America/Cayman",
		cityName: "George Town"
	},
	{
		identifier: "America/Curacao",
		cityName: "Willemstad"
	},
	{
		identifier: "America/Dominica",
		cityName: "Roseau"
	},
	{
		identifier: "America/Grenada",
		cityName: "Saint George's"
	},
	{
		identifier: "America/Guadeloupe",
		cityName: "Les Abymes"
	},
	{
		identifier: "America/Kralendijk",
		cityName: "Kralendijk"
	},
	{
		identifier: "America/Lower_Princes",
		cityName: "Philipsburg"
	},
	{
		identifier: "America/Marigot",
		cityName: "Marigot"
	},
	{
		identifier: "America/Montserrat",
		cityName: "Brades"
	},
	{
		identifier: "America/Nassau",
		cityName: "Nassau"
	},
	{
		identifier: "America/Port_of_Spain",
		cityName: "Chaguanas"
	},
	{
		identifier: "America/St_Barthelemy",
		cityName: "Gustavia"
	},
	{
		identifier: "America/St_Kitts",
		cityName: "Basseterre"
	},
	{
		identifier: "America/St_Lucia",
		cityName: "Castries"
	},
	{
		identifier: "America/St_Thomas",
		cityName: "Saint Croix"
	},
	{
		identifier: "America/St_Vincent",
		cityName: "Kingstown"
	},
	{
		identifier: "America/Tortola",
		cityName: "Road Town"
	},
	{
		identifier: "Arctic/Longyearbyen",
		cityName: "Longyearbyen"
	},
	{
		identifier: "Asia/Aden",
		cityName: "Sanaa"
	},
	{
		identifier: "Asia/Bahrain",
		cityName: "Ar Rifā‘"
	},
	{
		identifier: "Asia/Brunei",
		cityName: "Bandar Seri Begawan"
	},
	{
		identifier: "Asia/Kuala_Lumpur",
		cityName: "Kuala Lumpur"
	},
	{
		identifier: "Asia/Kuwait",
		cityName: "Al Aḩmadī"
	},
	{
		identifier: "Asia/Muscat",
		cityName: "Muscat"
	},
	{
		identifier: "Asia/Phnom_Penh",
		cityName: "Phnom Penh"
	},
	{
		identifier: "Asia/Vientiane",
		cityName: "Vientiane"
	},
	{
		identifier: "Atlantic/Reykjavik",
		cityName: "Reykjavík"
	},
	{
		identifier: "Atlantic/St_Helena",
		cityName: "Jamestown"
	},
	{
		identifier: "Europe/Amsterdam",
		cityName: "Amsterdam"
	},
	{
		identifier: "Europe/Bratislava",
		cityName: "Bratislava"
	},
	{
		identifier: "Europe/Copenhagen",
		cityName: "Copenhagen"
	},
	{
		identifier: "Europe/Guernsey",
		cityName: "Saint Peter Port"
	},
	{
		identifier: "Europe/Isle_of_Man",
		cityName: "Douglas"
	},
	{
		identifier: "Europe/Jersey",
		cityName: "Saint Helier"
	},
	{
		identifier: "Europe/Ljubljana",
		cityName: "Ljubljana"
	},
	{
		identifier: "Europe/Luxembourg",
		cityName: "Luxembourg"
	},
	{
		identifier: "Europe/Mariehamn",
		cityName: "Mariehamn"
	},
	{
		identifier: "Europe/Monaco",
		cityName: "Monaco"
	},
	{
		identifier: "Europe/Oslo",
		cityName: "Oslo"
	},
	{
		identifier: "Europe/Podgorica",
		cityName: "Podgorica"
	},
	{
		identifier: "Europe/San_Marino",
		cityName: "San Marino"
	},
	{
		identifier: "Europe/Sarajevo",
		cityName: "Sarajevo"
	},
	{
		identifier: "Europe/Skopje",
		cityName: "Skopje"
	},
	{
		identifier: "Europe/Stockholm",
		cityName: "Stockholm"
	},
	{
		identifier: "Europe/Vaduz",
		cityName: "Vaduz"
	},
	{
		identifier: "Europe/Vatican",
		cityName: "Vatican City"
	},
	{
		identifier: "Europe/Zagreb",
		cityName: "Zagreb"
	},
	{
		identifier: "Indian/Antananarivo",
		cityName: "Antananarivo"
	},
	{
		identifier: "Indian/Christmas",
		cityName: "Flying Fish Cove"
	},
	{
		identifier: "Indian/Cocos",
		cityName: "West Island"
	},
	{
		identifier: "Indian/Comoro",
		cityName: "Moroni"
	},
	{
		identifier: "Indian/Kerguelen",
		cityName: "Port-aux-Français"
	},
	{
		identifier: "Indian/Mahe",
		cityName: "Victoria"
	},
	{
		identifier: "Indian/Mayotte",
		cityName: "Mamoudzou"
	},
	{
		identifier: "Indian/Reunion",
		cityName: "Saint-Denis"
	},
	{
		identifier: "Pacific/Chuuk",
		cityName: "Chuuk"
	},
	{
		identifier: "Pacific/Funafuti",
		cityName: "Funafuti"
	},
	{
		identifier: "Pacific/Majuro",
		cityName: "Majuro"
	},
	{
		identifier: "Pacific/Midway",
		cityName: "Midway"
	},
	{
		identifier: "Pacific/Pohnpei",
		cityName: "Palikir - National Government Center"
	},
	{
		identifier: "Pacific/Saipan",
		cityName: "Saipan"
	},
	{
		identifier: "Pacific/Wake",
		cityName: "Wake"
	},
	{
		identifier: "Pacific/Wallis",
		cityName: "Mata-Utu"
	},
	{
		identifier: "Africa/Timbuktu",
		cityName: "Timbuktu"
	},
	{
		identifier: "America/Coral_Harbour",
		cityName: "Coral Harbour"
	},
	{
		identifier: "America/Ensenada",
		cityName: "Ensenada"
	},
	{
		identifier: "America/Montreal",
		cityName: "Montreal"
	},
	{
		identifier: "America/Nipigon",
		cityName: "Nipigon"
	},
	{
		identifier: "America/Rainy_River",
		cityName: "Rainy River"
	},
	{
		identifier: "America/Rosario",
		cityName: "Rosario"
	},
	{
		identifier: "America/Santa_Isabel",
		cityName: "Santa Isabel"
	},
	{
		identifier: "America/Thunder_Bay",
		cityName: "Thunder Bay"
	},
	{
		identifier: "America/Yellowknife",
		cityName: "Yellowknife"
	},
	{
		identifier: "Asia/Tel_Aviv",
		cityName: "Tel Aviv"
	},
	{
		identifier: "Australia/Canberra",
		cityName: "Canberra"
	},
	{
		identifier: "Australia/Currie",
		cityName: "Currie"
	},
	{
		identifier: "Europe/Tiraspol",
		cityName: "Tiraspol"
	},
	{
		identifier: "Europe/Uzhgorod",
		cityName: "Uzhgorod"
	},
	{
		identifier: "Pacific/Enderbury",
		cityName: "Enderbury"
	},
	{
		identifier: "Pacific/Yap",
		cityName: "Yap"
	},
	{
		identifier: "America/Godthab",
		cityName: "Godthab"
	},
	{
		identifier: "Asia/Istanbul",
		cityName: "Istanbul"
	},
	{
		identifier: "Europe/Kiev",
		cityName: "Kyiv"
	},
	{
		identifier: "Europe/Nicosia",
		cityName: "Nicosia"
	},
	{
		identifier: "Pacific/Truk",
		cityName: "Truk"
	}
];